import {PRNG} from "../RNG";

// from: https://github.com/bryc/code/blob/master/jshash/PRNGs.md
export class RNG_SFC32 extends PRNG {
	// declare only, else overwrites values set by InitState
	declare a: number;
	declare b: number;
	declare c: number;
	declare d: number;
	InitState_Generic(stateShiftsForInit = 30) {
		this.a = this.seed_int;
		this.b = this.seed_int;
		this.c = this.seed_int;
		this.d = this.seed_int;
		// go through X state-shifts before considering state initialized
		for (let i = 0; i < stateShiftsForInit; i++) {
			//this.GetNextSample();
			//for (let i = 0; i < 200; i++) {
			this.GetNextInt(0, 255); // correct?
		}
	}
	// seed procedure as recommended by the author
	InitState() {
		/* eslint-disable */
		this.a = 0;//a gets mixed in the slowest
		this.b = Math.abs(this.seed_int >> 0);
		this.c = Math.abs(this.seed_int >> 32);
		/* eslint-enable */
		for (let i = 0; i < 12; i++) {
			//this.GetNextSample();
			this.GetNextInt(0, 255); // correct?
		}
		this.GetNextUint32_callsSinceInitState = 0;
	}

	GetNextUint32_callsSinceInitState = 0;
	GetNextUint32() {
		this.GetNextUint32_callsSinceInitState++;
		/* eslint-disable */
		this.a >>>= 0; this.b >>>= 0; this.c >>>= 0; this.d >>>= 0; 
      let t = (this.a + this.b) | 0;
      this.a = this.b ^ this.b >>> 9;
      this.b = this.c + (this.c << 3) | 0;
      this.c = (this.c << 21 | this.c >>> 11);
      this.d = this.d + 1 | 0;
      t = t + this.d | 0;
      this.c = this.c + t | 0;
      //return (t >>> 0) / 4294967296;
      return t >>> 0;
		/* eslint-enable */
	}
}